// extracted by mini-css-extract-plugin
export default {"gallery_2_section":"gallery2_gallery_2_section__Qwjqe"};